import * as React from 'react';

import {
    getOrderTree,
    getSegmentInverseIndex,
    getTreeData,
    Section,
    ServerRate,
    ServerSection,
    TreeSection
} from '../../service/Experiments/Experiments';
import { ExperimentsControl } from '../ExperimentsControl/ExperimentsControl';

interface ExperimentsProviderProps {
    onChange: (state: { data: Record<string, Section>; isTargetingActive: boolean; isRatesActive: boolean }) => void;
    sections: Array<ServerSection>;
    rates?: {
        isEnabled: boolean;
        data: Array<ServerRate>;
    };
    checkedSections?: Array<number>;
    checkedSegments?: Array<number>;
    view?: 'classic' | 'default';
}

interface ExperimentsProviderState {
    segmentInverseIndex: Record<string, Section['section_id']>;
    treeData: Record<string, Section>;
    treeOrder: Array<TreeSection>;
    isTargetingEmpty: boolean;
    isTargetingActive: boolean;
    isRatesActive: boolean;
    isShowOnlySelected: boolean;
}

export class ExperimentsProvider extends React.Component<ExperimentsProviderProps, ExperimentsProviderState> {
    public static defaultProps: Partial<ExperimentsProviderProps> = {
        view: 'default',
        checkedSections: [],
        checkedSegments: [],
        rates: {
            isEnabled: false,
            data: []
        }
    };

    constructor(props: ExperimentsProviderProps) {
        super(props);

        const isTargetingActive = !!props.checkedSegments!.length;

        this.state = {
            segmentInverseIndex: getSegmentInverseIndex(props.sections),
            treeOrder: getOrderTree(props.sections),
            treeData: getTreeData(props.sections, props.checkedSections!, props.checkedSegments!, props.rates!.data),
            isRatesActive: props.rates!.isEnabled,
            isShowOnlySelected: false,
            isTargetingEmpty: !isTargetingActive,
            isTargetingActive: isTargetingActive
        };
    }

    componentWillReceiveProps(nextProps: ExperimentsProviderProps) {
        if (this.props.sections !== nextProps.sections) {
            this.setState({
                segmentInverseIndex: getSegmentInverseIndex(nextProps.sections),
                treeOrder: getOrderTree(nextProps.sections),
                treeData: getTreeData(
                    nextProps.sections,
                    nextProps.checkedSections!,
                    nextProps.checkedSegments!,
                    nextProps.rates!.data
                )
            });
        }
    }

    componentDidUpdate() {
        this.props.onChange({
            data: this.state.treeData,
            isTargetingActive: this.state.isTargetingActive,
            isRatesActive: this.state.isRatesActive
        });
    }

    render() {
        const { view } = this.props;
        const {
            treeOrder,
            treeData,
            isTargetingEmpty,
            isTargetingActive,
            isRatesActive,
            segmentInverseIndex,
            isShowOnlySelected
        } = this.state;

        return (
            <ExperimentsControl
                onChange={this.onControlChange}
                segmentInverseIndex={segmentInverseIndex}
                treeData={treeData}
                treeOrder={treeOrder}
                isTargetingActive={isTargetingActive}
                isTargetingEmpty={isTargetingEmpty}
                isRatesActive={isRatesActive}
                isShowOnlySelected={isShowOnlySelected}
                view={view}
            />
        );
    }

    /**
     * Обработчик изменения выбранных экспериментов
     */
    private onControlChange = (state: ExperimentsProviderState): void => {
        this.setState(state);
    };
}
